<app-header (locale)="onLocaleChange($event)"></app-header>
<div class="app-body mt-1 pt-1">
  <main class="main d-flex align-items-center">
    <div class="container pt-0">
      <div class="card">
        <div
          class="card-body px-4 px-md-5 py-3 py-md-5 card_width shadow-no-mobile shadow mx-auto"
        >
          <div class="alert-wrapper w-100 justify-content-center">
            <div class="container text-center">
              <div class="d-flex flex-row alert-flex-row w-100">
                <div class="d-flex w-100">
                  <div
                    *ngIf="(state$ | async).status === 'FAILED'"
                    role="alert"
                    class="alert alert-danger w-100 mb-0"
                  >
                    <div
                      *ngIf="
                        (state$ | async).errorMessage ===
                          'User with email does not exist in the system';
                        then thenBlock;
                        else elseBlock
                      "
                    ></div>
                    <ng-template #thenBlock>
                      <div
                        class="forgot-wrapper d-flex flex-row justify-content-center align-items-center pt-2"
                      >
                        <div
                          class="d-flex btn-pre-text text-dark-blue comma-field"
                        >
                          {{ 'admin.forgot.emailNotRegister' | translate }}
                        </div>
                        <div
                          *ngIf="checkIsIOS()"
                          class="d-flex btn-pre-text text-dark-blue"
                        >
                          {{ 'admin.forgot.emailNotRegister' | translate }}
                        </div>
                        <app-button
                          type="button"
                          variant="none"
                          classes="btn-link d-flex px-0"
                          *ngIf="!checkIsIOS()"
                          routerLink="/register"
                        >
                          {{ 'admin.login.signUp' | translate }}
                        </app-button>
                      </div>
                    </ng-template>
                    <ng-template #elseBlock
                      ><strong>Error!</strong
                      >{{ (state$ | async).errorMessage }}</ng-template
                    >
                  </div>
                </div>
              </div>
            </div>
          </div>
          <form
            [formGroup]="emailForm"
            *ngIf="(state$ | async).status !== 'RESET_PASSWORD_SENT'"
          >
            <h1 class="mb-4 primary-brand-color">
              {{ 'admin.forgot.header' | translate }}
            </h1>
            <div
              class="row text-reset"
              [ngClass]="{
                'mb-2':
                  (email.touched && email.errors && email.errors.required) ||
                  (email.touched && email.errors && email.errors.email),
              }"
            >
              <div class="col-12">
                <app-mat-input
                  [control]="$any(email)"
                  label="admin.global.email"
                  inputId="forgot-password-email-field"
                  fieldClass="mat-form-field-custom"
                  errorSuffix="."
                  [errors]="{
                    required: 'admin.global.field.required',
                    email: 'admin.user.details.emailErrorMsgInvaild',
                    maxlength: 'admin.global.field.maxLength',
                  }"
                ></app-mat-input>
              </div>
            </div>
            <div class="d-flex flex-row justify-content-center pt-1">
              <app-button
                type="submit"
                variant="primary"
                class="w-100"
                classes="w-100 py-3 font-weight-bold"
                dataTestid="forgot-password-submit-button"
                (click)="onSubmit()"
              >
                {{ 'admin.forgot.submit' | translate }}
              </app-button>
            </div>
            <div
              class="forgot-wrapper d-flex flex-row justify-content-center justify-content-md-start"
            >
              <div
                class="d-flex btn-pre-text pt-2 text-dark-blue align-items-center"
              >
                <span>{{ 'admin.forgot.alreadyKnow' | translate }}</span>
                <app-button
                  type="button"
                  variant="none"
                  classes="btn-link d-flex px-0"
                  (click)="goToLogin()"
                >
                  {{ 'admin.global.login' | translate }}
                </app-button>
              </div>
            </div>
          </form>
        </div>
      </div>
    </div>
  </main>
</div>
